import { html, ToniqSvg } from '../../toniq-svg';
export const BrandInstagram32Icon = new ToniqSvg('BrandInstagram32Icon', html `
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xml:space="preserve"
            width="32"
            height="32"
            fill-rule="evenodd"
            stroke-linejoin="round"
            stroke-miterlimit="2"
            clip-rule="evenodd"
            viewBox="0 0 32 32"
        >
            <path
                fill="url(#brand-instagram-32__a)"
                fill-rule="nonzero"
                d="M16 0C9.32 0 7.37 0 7 .04a7.93 7.93 0 0 0-3.16.8 6.87 6.87 0 0 0-3.7 5.24c-.1.74-.13.9-.14 4.71V16c0 6.68 0 8.63.04 9.01.11 1.34.32 2.18.76 3.1a6.74 6.74 0 0 0 4.37 3.56c.66.17 1.39.27 2.33.31.4.02 4.43.03 8.47.03 4.04 0 8.08 0 8.47-.02 1.08-.06 1.71-.14 2.4-.32a6.7 6.7 0 0 0 4.38-3.58c.43-.9.65-1.76.75-3.03.02-.27.03-4.67.03-9.06 0-4.4-.01-8.78-.03-9.05a7.8 7.8 0 0 0-.77-3.07A6.9 6.9 0 0 0 25.93.14c-.74-.1-.9-.13-4.72-.14h-5.2Z"
            />
            <path
                fill="url(#brand-instagram-32__b)"
                fill-rule="nonzero"
                d="M16 0C9.32 0 7.37 0 7 .04a7.93 7.93 0 0 0-3.16.8 6.87 6.87 0 0 0-3.7 5.24c-.1.74-.13.9-.14 4.71V16c0 6.68 0 8.63.04 9.01.11 1.34.32 2.18.76 3.1a6.74 6.74 0 0 0 4.37 3.56c.66.17 1.39.27 2.33.31.4.02 4.43.03 8.47.03 4.04 0 8.08 0 8.47-.02 1.08-.06 1.71-.14 2.4-.32a6.7 6.7 0 0 0 4.38-3.58c.43-.9.65-1.76.75-3.03.02-.27.03-4.67.03-9.06 0-4.4-.01-8.78-.03-9.05a7.8 7.8 0 0 0-.77-3.07A6.9 6.9 0 0 0 25.93.14c-.74-.1-.9-.13-4.72-.14h-5.2Z"
            />
            <path
                fill="#fff"
                d="M16 4.18c-3.21 0-3.61.02-4.87.08a8.68 8.68 0 0 0-2.87.54c-.78.3-1.44.71-2.1 1.37a5.8 5.8 0 0 0-1.36 2.1c-.29.74-.49 1.6-.54 2.86A84.36 84.36 0 0 0 4.17 16c0 3.21.02 3.61.08 4.87.05 1.26.25 2.12.54 2.87.3.78.7 1.44 1.37 2.1a5.8 5.8 0 0 0 2.09 1.36c.75.29 1.6.49 2.87.55 1.26.05 1.66.07 4.87.07 3.2 0 3.6-.02 4.87-.07a8.67 8.67 0 0 0 2.86-.55c.78-.3 1.44-.7 2.1-1.37a5.8 5.8 0 0 0 1.36-2.09c.29-.75.49-1.61.55-2.87.06-1.26.07-1.66.07-4.87a84 84 0 0 0-.07-4.87 8.77 8.77 0 0 0-.55-2.87 5.8 5.8 0 0 0-1.36-2.1 5.78 5.78 0 0 0-2.1-1.36 8.7 8.7 0 0 0-2.87-.54A84.32 84.32 0 0 0 16 4.18Zm-.4 2.13h.4c3.15 0 3.53.02 4.77.07 1.15.05 1.78.25 2.2.4.55.22.94.48 1.35.9.42.4.67.8.89 1.35.16.42.35 1.04.4 2.2.06 1.24.07 1.62.07 4.77 0 3.15-.01 3.53-.07 4.77a6.55 6.55 0 0 1-.4 2.2c-.22.55-.47.94-.89 1.35-.41.42-.8.67-1.36.89-.41.16-1.04.35-2.19.4-1.24.06-1.62.07-4.77.07-3.16 0-3.53-.01-4.78-.07a6.53 6.53 0 0 1-2.19-.4 3.66 3.66 0 0 1-1.36-.89c-.41-.41-.67-.8-.88-1.36a6.57 6.57 0 0 1-.4-2.19A83.6 83.6 0 0 1 6.3 16c0-3.16.02-3.53.07-4.78.05-1.15.25-1.78.4-2.2.22-.54.48-.94.9-1.35.4-.41.8-.67 1.35-.88a6.54 6.54 0 0 1 2.2-.41c1.08-.05 1.5-.07 3.7-.07h.67ZM20.9 9.7c0-.78.63-1.41 1.41-1.41a1.42 1.42 0 1 1-1.41 1.41Zm-4.9.24a6.07 6.07 0 1 0 0 12.14 6.07 6.07 0 0 0 0-12.14ZM19.95 16a3.94 3.94 0 1 0-7.88 0 3.94 3.94 0 0 0 7.88 0Z"
            />
            <defs>
                <radialGradient
                    id="brand-instagram-32__a"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientTransform="rotate(-90 21.48 12.98) scale(31.7144)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#fd5" />
                    <stop offset=".1" stop-color="#fd5" />
                    <stop offset=".5" stop-color="#ff543e" />
                    <stop offset="1" stop-color="#c837ab" />
                </radialGradient>
                <radialGradient
                    id="brand-instagram-32__b"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientTransform="rotate(78.68 -4.09 -2.12) scale(14.17646)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#3771c8" />
                    <stop offset=".13" stop-color="#3771c8" />
                    <stop offset="1" stop-color="#60f" stop-opacity=".01" />
                </radialGradient>
            </defs>
        </svg>
    `);
